import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { Issue } from '../issues/components/issue';
import { Activities } from './components/activities';
import { ActivityNew } from './components/activities-new';
import { ActivityEdit } from './components/activity-edit';
import { ActivityReassign } from './components/activity-reassign';
import { ActivityRevise } from './components/activity-revise';
import { ActivityFilterPage } from './components/activityFilterPage';

export const activityPaths = {
  root: 'activities',
};

export const activityRoutes = [
  {
    path: `${activityPaths.root}/*`,
    element: <Activities />,
    handle: {
      header: {
        titleKey: 'activity.menu.title',
        icon: 'bell-outline',
      },
      requiredPermission: Permissions.activity.read,
    },
    children: [
      {
        path: ':issueId',
        element: <Issue isComingFromActivities={true} />,
      },
      {
        path: ':issueId/asset/:assetId',
        element: <></>,
      },
    ],
  },
  {
    path: `${activityPaths.root}/filters`,
    element: <ActivityFilterPage />,
    handle: {
      header: {
        titleKey: 'activity.menu.title',
        icon: 'bell-outline',
      },
      requiredPermission: Permissions.activity.read,
    },
  },
  {
    path: `${activityPaths.root}/new`,
    element: <ActivityNew />,
    handle: {
      header: {
        titleKey: 'activity.menu.title',
        icon: 'bell-outline',
      },
      requiredPermission: Permissions.issue.create,
    },
  },
  {
    path: `${activityPaths.root}/:issueId/edit`,
    element: <ActivityEdit />,
    handle: {
      header: {
        titleKey: 'activity.menu.title',
        icon: 'bell-outline',
      },
      requiredPermission: Permissions.issue.update,
    },
  },
  {
    path: `${activityPaths.root}/:issueId/reassign`,
    element: <ActivityReassign />,
    handle: {
      header: {
        titleKey: 'activity.menu.title',
        icon: 'bell-outline',
      },
      requiredPermission: Permissions.issue.update,
    },
  },
  {
    path: `${activityPaths.root}/:issueId/revise`,
    element: <ActivityRevise />,
    handle: {
      header: {
        titleKey: 'activity.menu.title',
        icon: 'bell-outline',
      },
      requiredPermission: Permissions.issue.update,
    },
  },
];
